<template>
    <article class="grid-container layout-detail" v-if="!loading"><div style="display: none !important;"><svg><symbols><symbol id="sprite-triangle-left"><path data-name="Polygone 2 copie 4 copy 2 copie" d="M0 5l6-5v10z" fill-rule="evenodd"/></symbol><symbol id="sprite-icon-pdf"><path data-name="Forme 1" d="M5.78 16.371H4.64v1.68h1.14a.84.84 0 0 0 0-1.679zm4.61.034H9.25v3.022h1.14c1.85-.001 1.93-3.022 0-3.022zm6.17.053h-2v1.073h1.75a.52.52 0 0 1 .49.479.468.468 0 0 1-.49.4h-1.75v1.416a.4.4 0 0 1-.41.419.429.429 0 0 1-.48-.419V16a.426.426 0 0 1 .48-.419h2.41a.425.425 0 0 1 .48.419.471.471 0 0 1-.48.46zm-6.11 3.792H8.82a.428.428 0 0 1-.47-.419V16a.458.458 0 0 1 .47-.419h1.57c3.13 0 3.06 4.669.06 4.669zm-4.67-1.356H4.64v.891a.426.426 0 0 1-.44.465.458.458 0 0 1-.46-.466v-3.8a.462.462 0 0 1 .46-.466h1.58a1.687 1.687 0 1 1 0 3.374zm13.93-6.238H.86A.857.857 0 0 0 0 13.5v8.437a.857.857 0 0 0 .86.844h18.85a.857.857 0 0 0 .86-.844V13.5a.857.857 0 0 0-.86-.844zm3.43-6.255L17.5.844A3.247 3.247 0 0 0 15.43 0H6a2.552 2.552 0 0 0-2.57 2.531v8.438a.855.855 0 0 0 1.71 0V2.531A.856.856 0 0 1 6 1.687h7.71a1.7 1.7 0 0 1 1.72 1.688v3.164a1.919 1.919 0 0 0 1.92 1.9h3.22a1.7 1.7 0 0 1 1.71 1.687V24.47a.847.847 0 0 1-.85.843H6a.855.855 0 0 1-.86-.843.855.855 0 0 0-1.71 0A2.552 2.552 0 0 0 6 27h15.43A2.559 2.559 0 0 0 24 24.469V8.438a3.121 3.121 0 0 0-.86-2.037z" fill-rule="evenodd"/></symbol></symbols></svg></div>
        <header class="article-header flex-container flex-dir-column align-middle" v-if="$slots.header">
            <button class="btn btn-return" @click="$router.go(-1)" v-if="($route.name === localizedRoute('SingleStaticDetail') || $route.params.overrideBack || (lastRoute && lastRoute.name.includes('NotificationList')))  && user && user.access_right_group !== 'Tactical'">
                <svg inline="" width="10" height="15" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 10"><use xlink:href="#sprite-triangle-left"></use></svg>
                <translate>Back</translate>
            </button>
            <router-link class="btn btn-return" :to="{name: localizedRoute(backRoute)}" v-else-if="($route.name !== localizedRoute('SingleStaticList') && !$route.params.overrideBack && !$route.params.preventBack && backRoute)  && user && user.access_right_group !== 'Tactical'">
                <svg inline="" width="10" height="15" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 10"><use xlink:href="#sprite-triangle-left"></use></svg>
                <translate v-translate>Back</translate>
            </router-link>
            <router-link class="btn btn-return" :to="{name: localizedRoute('Home')}" v-else-if="($route.name !== localizedRoute('SingleStaticList'))  && user && user.access_right_group !== 'Tactical'">
                <svg inline="" width="10" height="15" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 10"><use xlink:href="#sprite-triangle-left"></use></svg>
                <span v-translate>Back</span>
            </router-link>
            <slot name="header"></slot>
        </header>
        <div class="article-wrapper" :class="{'with-author': author}">
            <div class="article-container">
                <div class="field-group-img flex-container flex-dir-column align-middle" v-if="author">
                    <div class="field-img">
                        <bmr-busy v-if="loading"></bmr-busy>
                        <img :src="author.profile_url || '/static/img/placeholder-158-158.png'" alt="" />
                    </div>
                </div>

                <div class="article-banner" v-if="$slots.banner">
                    <slot name="banner"></slot>
                </div>
                <div class="article-content" v-if="$slots.default">
                    <slot></slot>
                </div>

                <div class="article-footer text-center" v-if="$slots.footer">
                    <slot name="footer"></slot>
                </div>

                <div v-if="files && files.linked_files && files.linked_files.length">
                    <h2 class="h2" v-translate>Linked Files</h2>
                    <div class="article-documents grid-x">
                        <a v-for="file in files.linked_files" target="_blank" :href="file.url" class="cell document-item flex-container" :key="`document-${file.id}`">
                            <div class="document-img">
                                <svg inline="" width="24" height="27" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 27"><use xlink:href="#sprite-icon-pdf"></use></svg>
                            </div>
                            <div class="document-content">
                                <h3 class="document-title">{{ file.name }}</h3>
                                {{ getFileExtension(file.url) }} &bull; {{ file.size }}
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </article>
    <bmr-spinner padding="16px" :center="true" v-else></bmr-spinner>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('bmr');

export default {
    props: ['author', 'files', 'loading', 'backRoute'],
    computed: {
        ...mapState(['lastRoute', 'user']),
    },
    methods: {
        getFileExtension (fileUrl) {
            return fileUrl.split('.').pop().toUpperCase();
        },
    }
};
</script>

<style lang="scss" scoped>
.article-header {
    max-width: 768px;
    margin: 0 auto;
    margin-bottom: 20px;
    .h3 {
        margin: 0;
    }
    p {
        font-style: italic;
        font-weight: 700;
        color: $c-date-color;
    }
}
.article-wrapper {
    position: relative;
    max-width: 768px;
    margin: 0 auto;
    background-color: $solid-white;
    border: 1px solid $c-border-color;
    color: $c-date-color;
    &.with-author {
        margin-top: 50px;
    }
}
.article-container {
    @include rem-typo(16px);
    max-width: 540px;
    margin: 0 auto;
    padding: 30px 20px;
    @include breakpoint(medium) {
        padding: 70px 20px;
    }
    .with-author & {
        padding-top: 120px;
        @include breakpoint(medium) {
            padding-top: 130px;
        }
    }
}
.article-documents {
    margin: -4px;
    flex-wrap: wrap;
}
.document-item {
    @include rem-typo(13px);
    border: 1px solid $c-border-color;
    padding: 10px;
    margin: 4px;
    width: calc(100% - 8px);
    text-decoration: none;
    color: $c-documents;
    font-weight: 700;
    @include breakpoint(600px) {
        width: calc(50% - 8px);
    }
    .document-img {
        fill: $c-atelier;
        flex-shrink: 0;
        padding-top: 4px;
    }
    .document-content {
        margin-left: 8px;
    }
    .document-title {
        @include rem-typo(13px);
        font-weight: 700;
        color: $c-atelier;
        margin-bottom: 0;
        word-break: break-all;
    }
}
.article-footer {
    margin-top: 32px;
    border: 1px solid $c-border-color;
    padding: 20px;
}
.field-group-img {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -55px);
}
.field-img {
    position: relative;
    display: flex;
    border-radius: 50%;
    overflow: hidden;
    width: 160px;
    height: 160px;
    border: 1px solid $c-border-color;
    background-color: $white;
    img {
        min-width: 100%;
        min-height: 100%;
        object-fit: cover;
    }
}

.article-banner {
    margin: 20px -40px;
    min-width: calc(100% + 80px);
}
.article-content {
    margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/LayoutDetail.vue